var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08031 7.90477C6.07074 7.917 6.05852 7.92688 6.04457 7.93368C6.03061 7.94048 6.01529 7.94401 5.99977 7.94401C5.98425 7.94401 5.96893 7.94048 5.95498 7.93368C5.94102 7.92688 5.9288 7.917 5.91923 7.90477L4.48743 6.09328C4.43501 6.02681 4.48231 5.92837 4.56797 5.92837H5.51526V1.60227C5.51526 1.54602 5.56128 1.5 5.61753 1.5H6.38457C6.44082 1.5 6.48684 1.54602 6.48684 1.60227V5.92709H7.43158C7.51723 5.92709 7.56453 6.02553 7.51212 6.09201L6.08031 7.90477Z",
    fill: "#323234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91161 7.45752H10.6787C10.7349 7.45752 10.7809 7.50354 10.7809 7.55979V10.091C10.7809 10.3173 10.5981 10.5001 10.3718 10.5001H1.63333C1.40705 10.5001 1.22424 10.3173 1.22424 10.091V7.55979C1.22424 7.50354 1.27027 7.45752 1.32651 7.45752H2.09355C2.1498 7.45752 2.19583 7.50354 2.19583 7.55979L2.19009 9.52852H9.80934V7.55979C9.80934 7.50354 9.85536 7.45752 9.91161 7.45752Z",
    fill: "#323234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2b3d8e2474bc9c706fb15e818aa44563.svg";
export { ForwardRef as ReactComponent };